import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fc-not-found-preview',
  imports: [],
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 474 393"
      fill="none"
    >
      <path
        fill="#F2F2F2"
        d="M101.109 161.651c1.256.729 1.294 1.87.039 2.599l-35.989 20.932c-1.226.71-3.23.71-4.485-.019l-36.2-20.913c-1.255-.729-1.236-1.87-.018-2.59l35.988-20.931c1.246-.729 3.201-.729 4.466 0l36.199 20.912v.01Z"
      />
      <path
        fill="#FB8422"
        d="M96.52 159.1v2.763c0 .393-.27.786-.797 1.093v-2.763c.537-.307.796-.7.796-1.093ZM29.094 161.843v-2.763c0 .403.269.806.815 1.113v2.762c-.546-.316-.815-.719-.815-1.112Z"
      />
      <path
        fill="#FB8422"
        d="m60.98 178.149-.009 2.763L29.9 162.955v-2.763l31.082 17.957ZM95.733 160.192l-.01 2.763-30.9 17.967.01-2.754 30.9-17.976Z"
      />
      <path
        fill="#FB8422"
        d="M64.834 178.17v2.763c-1.064.614-2.78.614-3.863-.01v-2.762c1.083.623 2.808.623 3.863.009Z"
      />
      <path
        fill="#FDA23A"
        d="M95.694 157.958c1.083.623 1.103 1.611.039 2.235l-30.9 17.966c-1.054.614-2.77.614-3.852-.009l-31.082-17.957c-1.083-.624-1.064-1.612-.01-2.226L60.79 140c1.073-.623 2.75-.623 3.834 0l31.081 17.958h-.01Z"
      />
      <path
        fill="#FA9E35"
        d="M83.724 155.081h.019l-9.9-40.357-22.073-.058-9.88 40.204h.009c-1.16 3.818.814 7.904 5.932 10.859 8.32 4.806 21.766 4.834 30.037.057 5.032-2.906 6.968-6.926 5.856-10.705Z"
      />
      <path
        fill="#F2F2F2"
        d="m83.743 155.08-.585-2.388c-.958 1.89-2.712 3.664-5.28 5.151-8.272 4.777-21.718 4.758-30.037-.058-2.617-1.515-4.4-3.319-5.377-5.237l-.565 2.312h.01c-1.16 3.818.814 7.904 5.932 10.858 8.319 4.806 21.765 4.835 30.036.058 5.032-2.907 6.968-6.926 5.856-10.705h.02l-.01.009Z"
      />
      <path
        fill="#FFC584"
        d="M70.66 119.741c-4.312 2.494-11.318 2.474-15.66-.029-4.342-2.504-4.36-6.561-.048-9.046 4.313-2.494 11.32-2.475 15.66.029 4.342 2.504 4.362 6.561.049 9.046Z"
      />
      <path
        fill="#262626"
        d="M66.913 117.572c-2.252 1.305-5.913 1.295-8.185-.019-2.271-1.314-2.28-3.425-.028-4.729 2.252-1.305 5.913-1.295 8.184.019 2.272 1.314 2.281 3.424.03 4.729Z"
      />
      <path
        fill="#FA9E35"
        d="M58.7 115.203c2.252-1.304 5.913-1.295 8.185.019.603.346 1.035.758 1.322 1.199.786-1.189.355-2.599-1.322-3.568-2.272-1.314-5.933-1.314-8.185-.019-1.649.949-2.07 2.34-1.294 3.53.278-.422.71-.825 1.294-1.161Z"
      />
      <path
        fill="#F2F2F2"
        d="M76.67 126.197c-.048 2.024-1.4 3.99-4.016 5.525-5.415 3.137-14.194 3.108-19.618-.029-2.665-1.535-4.045-3.549-4.093-5.573l1.217-4.95c-.048.47 0 .931.106 1.401.105.412.259.834.489 1.218.565 1.093 1.629 2.129 3.105 2.983 4.974 2.849 13.005 2.878 17.932.029.93-.547 1.686-1.142 2.252-1.765.67-.748 1.093-1.554 1.294-2.36.134-.489.153-.988.077-1.477l1.245 5.007.01-.009ZM80.839 143.214c-.335 2.388-2.07 4.691-5.204 6.513-7.044 4.067-18.498 4.048-25.57-.048-3.192-1.842-4.946-4.173-5.291-6.59l1.524-6.197c.029.307.076.624.153.912.182.825.566 1.659 1.17 2.465.804 1.093 1.964 2.101 3.526 2.983 6.48 3.732 16.945 3.76 23.395.048 1.764-1.036 3.058-2.225 3.834-3.501.393-.624.652-1.247.776-1.89a5.32 5.32 0 0 0 .154-.911l1.523 6.225.01-.009ZM276.918 362.369c1.256.729 1.294 1.871.039 2.6L240.968 385.9c-1.226.71-3.23.71-4.485-.019l-36.199-20.912c-1.256-.729-1.237-1.871-.02-2.59l35.989-20.932c1.246-.729 3.201-.729 4.466 0l36.199 20.912v.01Z"
      />
      <path
        fill="#FB8422"
        d="M272.328 359.816v2.763c0 .393-.269.786-.796 1.093v-2.762c.537-.307.796-.7.796-1.094ZM204.903 362.561v-2.763c0 .403.269.806.815 1.113v2.763c-.546-.317-.815-.72-.815-1.113Z"
      />
      <path
        fill="#FB8422"
        d="m236.789 378.867-.009 2.763-31.072-17.958v-2.762l31.081 17.957ZM271.542 360.91l-.01 2.762-30.899 17.967.009-2.753 30.9-17.976Z"
      />
      <path
        fill="#FB8422"
        d="M240.642 378.887v2.763c-1.064.614-2.779.614-3.862-.01v-2.762c1.083.623 2.808.623 3.862.009Z"
      />
      <path
        fill="#FDA23A"
        d="M271.503 358.675c1.083.624 1.103 1.612.039 2.235l-30.9 17.967c-1.054.614-2.769.614-3.852-.01l-31.082-17.957c-1.083-.623-1.064-1.611-.009-2.225l30.899-17.967c1.073-.624 2.751-.624 3.834 0l31.081 17.957h-.01Z"
      />
      <path
        fill="#FA9E35"
        d="M259.533 355.798h.019l-9.901-40.357-22.072-.058-9.881 40.203h.009c-1.159 3.818.815 7.905 5.933 10.86 8.319 4.806 21.766 4.834 30.037.057 5.031-2.907 6.967-6.926 5.856-10.705Z"
      />
      <path
        fill="#F2F2F2"
        d="m259.552 355.798-.585-2.389c-.958 1.89-2.712 3.665-5.281 5.152-8.271 4.777-21.717 4.757-30.036-.058-2.617-1.516-4.399-3.319-5.377-5.238l-.566 2.312h.01c-1.16 3.818.815 7.904 5.933 10.859 8.319 4.806 21.765 4.835 30.036.058 5.032-2.907 6.968-6.926 5.856-10.706h.019l-.009.01Z"
      />
      <path
        fill="#FFC584"
        d="M246.469 320.457c-4.312 2.494-11.318 2.475-15.66-.028-4.342-2.504-4.361-6.562-.048-9.046 4.313-2.494 11.319-2.475 15.661.029 4.341 2.503 4.36 6.561.047 9.045Z"
      />
      <path
        fill="#262626"
        d="M242.722 318.29c-2.252 1.305-5.913 1.295-8.185-.019-2.271-1.314-2.281-3.425-.029-4.729 2.253-1.305 5.914-1.295 8.185.019 2.272 1.314 2.281 3.425.029 4.729Z"
      />
      <path
        fill="#FA9E35"
        d="M234.509 315.921c2.252-1.304 5.913-1.295 8.184.02.604.345 1.035.757 1.323 1.199.786-1.19.355-2.6-1.323-3.569-2.271-1.314-5.932-1.314-8.184-.019-1.649.95-2.071 2.341-1.294 3.53.278-.422.709-.825 1.294-1.161Z"
      />
      <path
        fill="#F2F2F2"
        d="M252.479 326.915c-.048 2.024-1.4 3.99-4.016 5.525-5.415 3.137-14.194 3.108-19.619-.029-2.664-1.535-4.044-3.549-4.092-5.573l1.217-4.95c-.048.47 0 .931.105 1.401.106.412.259.834.489 1.218.566 1.094 1.63 2.13 3.105 2.983 4.975 2.849 13.006 2.878 17.932.029.93-.547 1.687-1.141 2.253-1.765.671-.748 1.092-1.554 1.294-2.36a3.5 3.5 0 0 0 .076-1.477l1.246 5.007.01-.009ZM256.648 343.931c-.336 2.388-2.07 4.69-5.204 6.513-7.045 4.067-18.498 4.048-25.571-.048-3.191-1.842-4.945-4.173-5.29-6.59l1.524-6.197c.028.307.076.624.153.911.182.825.565 1.66 1.169 2.466.805 1.093 1.965 2.101 3.527 2.983 6.479 3.732 16.945 3.76 23.395.048 1.764-1.036 3.057-2.225 3.834-3.501.393-.624.651-1.247.776-1.89.077-.307.134-.624.153-.911l1.524 6.225.01-.009Z"
      />
      <path
        fill="#0B3B4D"
        d="M368.28 211.378c.224-41.334-57.587-75.155-129.123-75.542-71.536-.388-129.709 32.806-129.932 74.14-.224 41.334 57.586 75.156 129.122 75.543 71.537.387 129.709-32.807 129.933-74.141Z"
      />
      <path
        fill="#1A5A71"
        d="M146.883 185.106c50.422-29.143 132.434-28.99 183.172.336 19.379 11.204 31.369 25.037 36.008 39.493 7.59-23.493-4.428-48.75-36.008-67.005-50.738-29.326-132.75-29.47-183.172-.336-31.158 18.005-42.947 42.985-35.442 66.363 4.6-14.246 16.398-27.848 35.442-38.851Z"
      />
      <path
        fill="#9D9D9D"
        d="m248.638 239.804 9.872-3.569-6.077 39.78-9.871 3.569 6.076-39.78ZM256.909 185.709l9.872-3.568-6.086 39.78-9.872 3.559 6.086-39.771Z"
      />
      <path
        fill="#F2F2F2"
        d="m252.433 276.008 13.725 7.923c-4.601.566-9.258.978-13.935 1.237l-9.671-5.592 9.881-3.578v.01Z"
      />
      <path
        fill="#9D9D9D"
        d="m265.18 131.597 9.872-3.568-6.086 39.79-9.872 3.568 6.086-39.79Z"
      />
      <path
        fill="#F2F2F2"
        d="m250.823 225.483 9.872-3.559 66.111 38.197-9.871 3.568-66.112-38.206ZM261.203 75.326l9.872-3.559 11.558 6.677-9.872 3.558-11.558-6.676Z"
      />
      <path
        fill="#9D9D9D"
        d="m272.761 82.003 9.872-3.559-5.396 35.282-9.872 3.558 5.396-35.28Z"
      />
      <path
        fill="#F2F2F2"
        d="m259.094 171.388 9.872-3.568 66.111 38.197-9.871 3.569-66.112-38.198ZM267.365 117.285l9.872-3.559 66.112 38.198-9.872 3.568-66.112-38.207ZM338.863 120.21l9.872-3.568 11.568 6.686-9.872 3.568-11.568-6.686Z"
      />
      <path
        fill="#E6E6E6"
        d="m338.863 120.21-4.092 26.754-1.304 8.509-66.111-38.189 5.396-35.282-11.549-6.677-9.316 60.924-22.781 149.034c7.696.345 15.43.306 23.107-.125l-9.67-5.593 6.085-39.771 8.569 4.949 50.891 29.402c7.543-2.734 14.693-5.966 21.306-9.698l14.808-96.878 6.22-40.702-11.559-6.667v.01Zm-73.683 11.387 8.569 4.949 5.462 3.166 52.071 30.073-4.773 31.282-1.303 8.509-66.112-38.189 5.185-33.996.892-5.794h.009Zm-14.347 93.884 6.067-39.772 8.568 4.95 57.533 33.239-4.773 31.263-1.303 8.509-66.092-38.189Z"
      />
      <path
        fill="#9D9D9D"
        d="m360.303 123.328-7.917 51.811-12.66 82.795c-2.818 2.015-5.856 3.953-9.086 5.833-.412.24-.824.46-1.236.7l14.807-96.877 6.22-40.703 9.881-3.559h-.009Z"
      />
      <path
        fill="#F2F2F2"
        d="M147.592 392.137 1.502 307.548c-2.224-1.285-1.946-3.53.622-5.007l13.207-7.626c2.569-1.487 6.45-1.641 8.674-.365l146.101 84.589c2.223 1.286 1.945 3.53-.623 5.008l-13.207 7.626c-2.569 1.487-6.45 1.64-8.674.364h-.01Z"
      />
      <path
        fill="#404040"
        d="M161.681 378.035v2.062c0 1.842-1.217 3.683-3.632 5.084-4.859 2.83-12.776 2.83-17.673 0-2.464-1.42-3.69-3.29-3.69-5.161v-2.062c0 1.861 1.226 3.731 3.69 5.161 4.907 2.829 12.814 2.829 17.673 0 2.415-1.401 3.623-3.243 3.632-5.084Z"
      />
      <path
        fill="#737373"
        d="M157.981 372.875c4.907 2.83 4.927 7.415.067 10.245-4.859 2.829-12.775 2.829-17.673 0-4.897-2.83-4.916-7.415-.057-10.245 4.859-2.83 12.775-2.83 17.663 0Z"
      />
      <path
        fill="#262626"
        d="M152.816 375.849c2.022 1.17 2.032 3.06.029 4.23-2.004 1.17-5.272 1.17-7.294 0-2.022-1.17-2.032-3.06-.019-4.221 2.003-1.17 5.271-1.17 7.284 0v-.009ZM161.681 378.045v2.063c0 1.832-1.217 3.674-3.632 5.074-2.444 1.429-5.655 2.139-8.866 2.12v-2.062c3.211.009 6.422-.691 8.866-2.12 2.415-1.401 3.632-3.243 3.632-5.075Z"
      />
      <path
        fill="#404040"
        d="M153.784 279.517v98.278c0 .681-.451 1.353-1.332 1.871-1.793 1.045-4.697 1.045-6.508 0-.911-.528-1.361-1.209-1.361-1.9v-98.278c0 .691.45 1.372 1.361 1.9 1.802 1.045 4.715 1.045 6.508 0 .891-.518 1.332-1.19 1.332-1.871Z"
      />
      <path
        fill="#262626"
        d="M153.774 279.517v98.269c0 .681-.441 1.362-1.342 1.87-.9.528-2.079.787-3.258.787v-98.278c1.179.009 2.358-.25 3.258-.777.901-.528 1.342-1.19 1.342-1.871Z"
      />
      <path
        fill="#737373"
        d="M152.424 277.618c1.801 1.046 1.811 2.734.028 3.77-1.792 1.036-4.696 1.036-6.507 0-1.802-1.036-1.812-2.724-.02-3.77 1.793-1.036 4.697-1.036 6.499 0Z"
      />
      <path
        fill="#404040"
        d="M152.538 273.839v5.036c0 .499-.326.989-.978 1.363-1.303.757-3.431.757-4.753 0-.662-.384-.997-.883-.988-1.391v-5.036c0 .498.326 1.007.988 1.391 1.322.757 3.44.757 4.753 0 .652-.375.978-.873.978-1.363Z"
      />
      <path
        fill="#737373"
        d="M151.551 272.448c1.323.757 1.323 1.995.019 2.753-1.303.757-3.431.757-4.753 0-1.313-.758-1.323-1.996-.019-2.753 1.303-.758 3.431-.758 4.753 0Z"
      />
      <path
        fill="#262626"
        d="M152.547 273.839v5.036c0 .489-.325.978-.977 1.362-.661.384-1.514.576-2.387.576v-5.036c.863 0 1.726-.192 2.387-.566.661-.375.977-.883.977-1.372Z"
      />
      <path
        fill="#404040"
        d="M33.35 303.816v2.062c0 1.842-1.218 3.684-3.633 5.084-4.86 2.83-12.776 2.83-17.673 0-2.463-1.419-3.69-3.29-3.69-5.161v-2.062c0 1.861 1.227 3.732 3.69 5.161 4.907 2.83 12.814 2.83 17.673 0 2.415-1.401 3.623-3.242 3.632-5.084Z"
      />
      <path
        fill="#737373"
        d="M29.66 298.656c4.907 2.839 4.926 7.415.067 10.245-4.86 2.83-12.776 2.83-17.674 0-4.897-2.83-4.916-7.415-.057-10.245 4.86-2.83 12.776-2.83 17.664 0Z"
      />
      <path
        fill="#262626"
        d="M24.484 301.629c2.022 1.17 2.032 3.06.029 4.23-2.003 1.171-5.271 1.171-7.294 0-2.022-1.17-2.031-3.06-.019-4.22 2.003-1.171 5.272-1.171 7.284 0v-.01ZM33.35 303.825v2.062c0 1.833-1.218 3.674-3.633 5.075-2.444 1.429-5.654 2.129-8.865 2.12v-2.063c3.21.01 6.421-.69 8.865-2.12 2.415-1.4 3.633-3.242 3.633-5.074Z"
      />
      <path
        fill="#404040"
        d="M25.452 205.299v98.278c0 .681-.45 1.352-1.332 1.87-1.792 1.046-4.696 1.046-6.508 0-.91-.527-1.36-1.208-1.36-1.899V205.27c0 .69.45 1.372 1.36 1.899 1.802 1.046 4.716 1.046 6.508 0 .891-.518 1.332-1.189 1.332-1.87Z"
      />
      <path
        fill="#262626"
        d="M25.452 205.297v98.269c0 .681-.44 1.362-1.342 1.87-.9.528-2.08.787-3.258.787v-98.278c1.178.01 2.357-.249 3.258-.777.901-.528 1.342-1.19 1.342-1.871Z"
      />
      <path
        fill="#737373"
        d="M24.092 203.398c1.801 1.046 1.811 2.734.028 3.77-1.792 1.045-4.696 1.045-6.507 0-1.802-1.046-1.812-2.724-.02-3.77 1.793-1.046 4.697-1.046 6.499 0Z"
      />
      <path
        fill="#404040"
        d="M24.216 199.619v5.036c0 .499-.326.989-.978 1.372-1.303.758-3.431.758-4.754 0-.66-.383-.996-.882-.987-1.391V199.6c0 .499.326 1.007.987 1.391 1.323.758 3.441.758 4.754 0 .652-.374.978-.873.978-1.362v-.01Z"
      />
      <path
        fill="#737373"
        d="M23.219 198.228c1.323.758 1.323 1.995.02 2.753-1.304.758-3.432.758-4.755 0-1.313-.758-1.322-1.995-.019-2.753 1.304-.758 3.431-.758 4.754 0Z"
      />
      <path
        fill="#262626"
        d="M24.216 199.62v5.036c0 .489-.326.978-.978 1.362-.661.384-1.514.575-2.386.575v-5.036c.862 0 1.725-.192 2.386-.566.662-.374.978-.882.978-1.371Z"
      />
      <path
        fill="#D9D9D9"
        d="m157.445 300.573-.077 25.689c0 1.132-.402 1.928-1.044 2.293l5.645-3.281c.642-.374 1.044-1.17 1.044-2.293l.077-25.688-5.645 3.28Z"
      />
      <path
        fill="#F2F2F2"
        d="M159.515 291.086 10.76 205.116c-.997-.576-1.898-.633-2.55-.25l-5.645 3.281c.652-.384 1.553-.326 2.55.249l148.765 85.961c1.983 1.142 3.584 3.924 3.574 6.197l5.646-3.28c0-2.274-1.601-5.056-3.575-6.197l-.01.009Z"
      />
      <path
        fill="#E6E6E6"
        d="M153.87 294.366c1.984 1.142 3.585 3.924 3.575 6.197l-.077 25.69c0 2.283-1.619 3.194-3.603 2.043L5.009 242.345c-1.984-1.142-3.584-3.914-3.575-6.197l.077-25.69c0-2.273 1.62-3.194 3.604-2.053l148.765 85.961h-.01Z"
      />
      <path
        fill="#FDA23A"
        d="m27.484 221.329-26.05 13.966.048-15.626 11.98-6.427 14.022 8.087ZM52.815 235.976l-30.506 16.365-13.993-8.096 30.506-16.356 13.993 8.087ZM78.165 250.614l-30.516 16.364-13.983-8.086 30.506-16.365 13.993 8.087ZM103.505 265.264l-30.506 16.374-14.002-8.096 30.506-16.365 14.002 8.087ZM128.856 279.911l-30.507 16.374-14.002-8.105 30.506-16.365 14.003 8.096ZM154.177 294.559l-30.487 16.365-14.003-8.087 30.507-16.365 13.667 7.895c.105.058.201.125.306.192h.01ZM157.435 305.475l-.048 15.607-8.357 4.49-13.983-8.087 22.388-12.01Z"
      />
      <path
        fill="#FFC584"
        d="m33.196 218.076-5.693 3.261-14.04-8.096 5.673-3.28 14.06 8.115ZM58.527 232.724l-5.674 3.261-14.05-8.115 5.664-3.271 14.06 8.125ZM83.867 247.362l-5.683 3.271-14.05-8.115 5.674-3.281 14.06 8.125ZM109.198 262.011l-5.674 3.261-14.05-8.106 5.674-3.28 14.05 8.125ZM134.529 276.64l-5.683 3.271-14.041-8.115 5.674-3.281 14.05 8.125ZM159.86 291.298l-5.693 3.261c-.105-.067-.192-.134-.297-.192l-13.715-7.933 5.664-3.281 13.696 7.914a3.5 3.5 0 0 1 .345.221v.01Z"
      />
      <path
        fill="#FDA23A"
        d="m163.09 302.233-.057 15.645-5.646 3.262.048-15.645 5.655-3.262Z"
      />
      <path
        fill="#E6C1C2"
        d="m122.357 310.166-67.328-38.899 17.127-24.097 33.266 19.224 16.935 43.772Z"
        style="mix-blend-mode:multiply"
      />
      <path
        fill="#FFC584"
        d="m111.096 263.114-5.674 3.281-21.18-12.24 5.673-3.271 21.181 12.23Z"
      />
      <path
        fill="#FA0"
        d="m114.911 311.951-6.729 3.914c.633-.365.844-1.41.336-2.715l6.728-3.914c.508 1.305.288 2.35-.335 2.715ZM72.367 225.807l6.728-3.913c.402-.24.948-.163 1.485.153l-6.728 3.914c-.537-.307-1.083-.384-1.485-.154ZM75.654 228.205l6.728-3.914 32.864 84.934-6.728 3.914-32.864-84.934Z"
      />
      <path
        fill="#FA0"
        d="m73.852 225.962 6.728-3.914c.7.403 1.41 1.218 1.802 2.245l-6.728 3.913c-.403-1.036-1.102-1.841-1.802-2.244Z"
      />
      <path
        fill="#FFEA00"
        d="M73.852 225.96c.7.403 1.409 1.218 1.802 2.244l32.864 84.935c.805 2.072-.211 3.501-1.821 2.571l-66.102-38.199c-1.62-.93-2.607-3.52-1.802-4.662l33.238-46.736c.403-.566 1.112-.566 1.821-.153Z"
      />
      <path
        fill="#FF3D44"
        d="M73.833 230.133c.642.364 1.275 1.103 1.639 2.043l29.807 77.039c.728 1.881-.192 3.176-1.649 2.332l-59.958-34.65c-1.467-.844-2.368-3.194-1.64-4.23l30.153-42.4c.364-.518 1.006-.509 1.648-.144v.01Z"
      />
      <path
        fill="#FFEA00"
        d="M73.814 233.442c.584.336 1.169 1.007 1.504 1.87l27.382 70.766c.671 1.727-.172 2.917-1.514 2.14l-55.07-31.829c-1.342-.777-2.176-2.936-1.505-3.885l27.688-38.937c.336-.471.93-.471 1.515-.135v.01Z"
      />
      <path
        fill="#000"
        d="m74.216 277.406-2.147-1.238c-.68-.393-1.227-1.448-1.227-2.35v-28.451c0-.911.547-1.324 1.227-.931l2.147 1.238c.68.393 1.227 1.448 1.227 2.35v28.451c0 .912-.546 1.324-1.227.931ZM75.894 285.666c0 1.746-1.227 2.446-2.751 1.573-1.514-.872-2.75-3.002-2.75-4.748 0-1.746 1.226-2.446 2.75-1.573 1.514.883 2.75 3.002 2.75 4.748Z"
      />
      <path
        fill="#F2F2F2"
        d="m279.154 323.55 28.426-16.394c.949-.547 2.387-.604 3.211-.134l11.29 6.494 98.123-56.559-12.23-7.041c-.824-.48-.718-1.305.23-1.851l28.427-16.394c.949-.547 2.386-.605 3.211-.135l32.892 18.936c.825.48.719 1.305-.23 1.852l-28.426 16.394c-.949.547-2.387.604-3.211.134l-4.907-2.82-98.122 56.559 5.846 3.367c.824.48.719 1.305-.23 1.851l-28.427 16.394c-.948.547-2.386.605-3.21.135l-32.893-18.936c-.824-.48-.719-1.305.23-1.852Z"
      />
      <path
        fill="gray"
        d="M434.398 234.21a7.02 7.02 0 0 1 .757-.374l14.52-6.264.029 9.555-14.52 6.263c-.269.116-.518.24-.757.375-1.294.748-2.032 1.765-2.032 2.944l-.029-9.554c0-1.189.738-2.206 2.032-2.945ZM436.113 254.96c7.926 0 13.619-1.794 17.683-4.144 7.648-4.422 9.412-10.466 9.508-10.782l.028 9.554c-.096.317-1.859 6.369-9.507 10.782-4.064 2.35-9.766 4.144-17.683 4.144-3.46 0-6.776.844-9.229 2.264l-.029-9.554c2.453-1.42 5.769-2.264 9.229-2.264Z"
      />
      <path
        fill="gray"
        d="m342.716 305.859.029 9.555 84.168-48.645-.029-9.545-84.168 48.635Z"
      />
      <path
        fill="#C7C7C7"
        d="M302.999 310.138c1.428-.825 3.412-1.257 5.454-1.161 4.724.221 8.903 1.266 12.181 2.993 1.495.786 2.291 1.88 2.3 2.993l.029 9.554c0-1.113-.805-2.206-2.3-2.993-3.278-1.727-7.457-2.782-12.182-2.993-2.041-.096-4.025.336-5.453 1.161-.23.134-.451.278-.652.432l-.029-9.555c.202-.153.422-.297.652-.431Z"
      />
      <path
        fill="gray"
        d="m291.498 318.972.019 9.545 10.859-8.394-.029-9.554-10.849 8.403Z"
      />
      <path
        fill="#C7C7C7"
        d="M288.901 314.714c.613 2.676 2.492 4.182 2.597 4.259l.029 9.554c-.096-.077-1.984-1.583-2.597-4.259a6.775 6.775 0 0 1-.173-1.497l-.028-9.554c0 .499.057.998.172 1.497Z"
      />
      <path
        fill="#DEDEDE"
        d="M320.625 311.97c2.348 1.237 2.98 3.233 1.495 4.873l-9.182 10.073c.546-.048 10.983-1.056 18.632-5.478 4.063-2.35 7.188-5.65 7.207-10.245.009-2.005 1.476-3.923 3.929-5.343l84.168-48.636c2.454-1.419 5.77-2.263 9.23-2.263 7.926 0 13.619-1.794 17.683-4.145 7.648-4.422 9.411-10.465 9.507-10.782l-17.405 5.286c-2.827.854-6.277.489-8.405-.883-2.971-1.909-4.763-4.336-5.099-6.897-.182-1.353.575-2.504 2.003-3.329a7.02 7.02 0 0 1 .757-.374l14.52-6.264c-.134-.057-2.722-1.151-7.331-1.516-6.451-.508-12.584.854-16.907 3.348-3.105 1.794-5.271 4.173-5.942 6.859l-1.898 7.655c-.412 1.66-1.744 3.204-3.795 4.384l-86.42 49.94c-2.051 1.19-4.716 1.957-7.581 2.187l-13.217 1.084c-4.629.374-8.741 1.621-11.836 3.415-4.323 2.494-6.69 6.053-5.837 9.795.613 2.676 2.492 4.182 2.597 4.259l10.85-8.394c.201-.153.421-.297.651-.432 1.428-.825 3.412-1.256 5.454-1.16 4.725.22 8.903 1.266 12.181 2.993l-.009-.01Z"
      />
      <path
        fill="#C7C7C7"
        d="m338.489 302.761 84.389-48.77-5.482-3.166-84.389 48.77 5.482 3.166Z"
      />
      <path
        fill="gray"
        d="m417.396 252.197-83.2 48.079-1.189-.681 84.389-48.77 5.482 3.166-1.189.691-4.293-2.485ZM312.938 326.915l.029 9.554c.546-.057 10.983-1.055 18.631-5.477 4.064-2.35 7.188-5.65 7.208-10.245.009-2.004 1.476-3.923 3.929-5.343l-.029-9.554c-2.453 1.42-3.92 3.338-3.929 5.343-.029 4.595-3.144 7.895-7.207 10.245-7.649 4.422-18.086 5.42-18.632 5.477Z"
      />
      <path
        fill="#F2F2F2"
        d="m430.737 211.648-59.441-34.352c-2.78-1.602-2.435-4.412.776-6.264l27.047-15.636c3.21-1.851 8.06-2.053 10.839-.451l59.441 34.352c2.779 1.602 2.425 4.413-.776 6.264l-27.047 15.636c-3.21 1.852-8.06 2.053-10.839.451Z"
      />
      <path
        fill="#595959"
        d="M466.284 171.57h-15.766v6.264l-39.544-22.85c-2.501-1.449-6.881-1.266-9.776.403l-2.108 1.218v-.528h-24.679v16.912h.028c.115.806.662 1.554 1.658 2.14l53.614 30.984c2.502 1.449 6.882 1.267 9.776-.403l24.401-14.101c1.534-.883 2.339-2.014 2.387-3.098h.009V171.56v.01Z"
      />
      <path
        fill="#333"
        d="M466.284 171.571v16.95h-.009c-.039 1.074-.853 2.206-2.377 3.098l-24.401 14.101c-1.198.691-2.655 1.132-4.131 1.295v-37.919l15.152 8.758v-6.264h15.766v-.019Z"
      />
      <path
        fill="#333"
        d="m429.721 189.547-53.614-30.984c-2.501-1.449-2.195-3.981.7-5.651l24.401-14.101c2.894-1.669 7.265-1.851 9.776-.403l53.613 30.985c2.502 1.448 2.195 3.981-.699 5.65l-24.401 14.101c-2.895 1.669-7.275 1.852-9.776.403Z"
      />
      <path
        fill="#FFC800"
        d="M466.284 153.316h-15.766v6.264l-39.544-22.85c-2.501-1.449-6.881-1.267-9.776.403l-2.108 1.218v-.528h-24.679v16.922h.028c.115.806.662 1.554 1.658 2.139l53.614 30.985c2.502 1.448 6.882 1.266 9.776-.403l24.401-14.102c1.534-.882 2.339-2.014 2.387-3.098h.009v-16.95Z"
      />
      <path
        fill="#FA0"
        d="M466.284 153.315v16.95h-.009c-.039 1.075-.853 2.207-2.377 3.099l-24.401 14.101c-1.198.69-2.655 1.132-4.131 1.295v-37.92l15.152 8.758v-6.263h15.766v-.02Z"
      />
      <path
        fill="#FFEA00"
        d="m429.721 171.281-53.614-30.984c-2.501-1.449-2.195-3.981.7-5.651l24.401-14.101c2.894-1.669 7.265-1.851 9.776-.403l53.614 30.985c2.501 1.448 2.194 3.981-.7 5.65l-24.401 14.101c-2.895 1.669-7.275 1.852-9.776.403Z"
      />
      <path
        fill="#FFF27A"
        d="m428.647 166.302-47.48-27.435c-2.213-1.286-1.936-3.521.623-4.998l21.603-12.48c2.559-1.477 6.441-1.641 8.655-.355l47.47 27.435c2.214 1.286 1.936 3.521-.623 4.998l-21.603 12.48c-2.559 1.478-6.44 1.641-8.654.355h.009Z"
      />
      <path
        fill="#FFFDE7"
        d="m393.78 166.246-9.603-5.612c-.173-.095-.403-.086-.661.058-.221.125-.422.336-.585.576-.211.316-.345.7-.345 1.036 0 .297.105.508.268.604l9.604 5.611.019-.038c.134.019.297-.019.469-.125.298-.172.556-.479.729-.825a1.89 1.89 0 0 0 .201-.796.79.79 0 0 0-.125-.46l.029-.039v.01Z"
      />
      <path
        fill="#B0918F"
        d="M393.138 166.314c-.518.297-.93 1.017-.93 1.621 0 .604.412.844.93.547.517-.298.929-1.017.929-1.621 0-.605-.412-.844-.929-.547Z"
      />
      <path
        fill="#FFFDE7"
        d="m423.357 183.349-9.603-5.612c-.173-.096-.403-.086-.662.058-.22.124-.421.335-.584.575-.211.317-.345.7-.345 1.036 0 .298.105.509.268.605l9.603 5.611.019-.038a.867.867 0 0 0 .47-.125c.297-.173.556-.48.728-.825.125-.259.202-.537.202-.796a.79.79 0 0 0-.125-.46l.029-.039v.01Z"
      />
      <path
        fill="#B0918F"
        d="M422.714 183.426c-.517.297-.929 1.017-.929 1.621 0 .604.412.844.929.547.518-.298.93-1.017.93-1.622 0-.604-.412-.844-.93-.546Z"
      />
      <path
        fill="#333"
        d="m406.259 138.685 5.214-3.021v-7.185l-5.214 3.031v7.175Z"
      />
      <path
        fill="#4D4D4D"
        d="m425.485 134.762-4.716-2.724-7.677-4.432-4.725-2.734-3.335 1.909-2.214 1.257v8.671l3.441 1.976v-7.175l3.498-2.005 14.357 8.298 3.498 6.043v7.185l3.431 1.986v-8.672l-5.558-9.583Z"
      />
      <path
        fill="#333"
        d="m431.043 153.018 5.224-3.032v-8.662l-5.224 3.022v8.672Z"
      />
      <path
        fill="#666"
        d="m430.721 131.74-5.224 3.03 5.55 9.587 5.224-3.03-5.55-9.587Z"
      />
      <path
        fill="#A3A3A3"
        d="m408.367 124.872 5.224-3.031 17.117 9.9-5.223 3.021-17.118-9.89Z"
      />
      <path
        fill="#311811"
        d="m402.818 128.038 5.549-3.166 5.224-3.031-5.55 3.166-5.223 3.031Z"
      />
      <path
        fill="#F2F2F2"
        d="M417.07 337.64c1.687.969 2.348 2.398 1.744 3.722l-4.265 9.352c-.603 1.334-2.386 2.37-4.686 2.725l-16.111 2.503c-2.291.355-4.744-.019-6.431-.997l-11.846-6.849c-1.687-.969-2.348-2.389-1.745-3.722l4.265-9.353c.604-1.333 2.387-2.369 4.687-2.724l16.111-2.504c2.291-.355 4.744.019 6.431.998l11.846 6.849Z"
      />
      <path
        fill="gray"
        d="m416.322 323.298-3.795 8.317c-.537 1.18-2.128 2.111-4.169 2.427l-14.338 2.226-.048 16.278 14.338-2.225c2.041-.317 3.632-1.238 4.169-2.427l3.795-8.317c.135-.288.202-.585.202-.873l.048-16.278c0 .287-.068.585-.202.872Z"
      />
      <path
        fill="#999"
        d="m388.298 335.386-10.542-6.091c-1.131-.652-1.745-1.535-1.745-2.437l-.048 16.279c0 .902.614 1.784 1.745 2.436l10.542 6.092c1.495.863 3.681 1.208 5.722.882l.048-16.278c-2.042.316-4.217-.02-5.722-.883Z"
      />
      <path
        fill="#D9D9D9"
        d="M414.78 319.989c1.495.863 2.089 2.13 1.543 3.309l-3.796 8.317c-.536 1.18-2.127 2.111-4.169 2.427l-14.338 2.226c-2.041.316-4.217-.02-5.721-.883l-10.543-6.091c-1.495-.864-2.089-2.13-1.543-3.31l3.795-8.316c.537-1.18 2.128-2.111 4.169-2.427l14.338-2.226c2.042-.316 4.217.019 5.722.883l10.543 6.091Z"
      />
      <path
        fill="#A3A3A3"
        d="M406.307 330.234c-5.281 3.051-13.878 3.041-19.188-.038-5.319-3.07-5.338-8.039-.057-11.089 5.281-3.05 13.878-3.041 19.187.038 5.319 3.07 5.339 8.039.058 11.089Z"
      />
      <path
        fill="gray"
        d="M387.052 322.292c5.281-3.05 13.878-3.041 19.188.039 1.964 1.132 3.201 2.522 3.718 3.98.892-2.503-.345-5.218-3.718-7.165-5.319-3.07-13.907-3.089-19.188-.038-3.335 1.928-4.552 4.613-3.661 7.108.518-1.439 1.735-2.811 3.661-3.924Z"
      />
      <path
        fill="gray"
        d="M409.518 327.27a7.057 7.057 0 0 1-1.314 1.583 10.96 10.96 0 0 0-1.955-1.429c-5.319-3.07-13.906-3.089-19.187-.039-.729.423-1.371.893-1.898 1.382a7.18 7.18 0 0 1-1.313-1.602c.642-1.084 1.716-2.101 3.201-2.964 5.281-3.051 13.878-3.041 19.188.038 1.524.883 2.616 1.919 3.268 3.022l.01.009Z"
      />
      <path
        fill="gray"
        d="M406.987 329.813c-.22.144-.441.287-.68.422-.786.451-1.639.834-2.55 1.151-4.332-1.554-9.823-1.564-14.155-.048a14.75 14.75 0 0 1-2.492-1.142c-.259-.144-.499-.307-.738-.46.22-.144.441-.288.68-.422 5.281-3.051 13.878-3.041 19.188.038.258.144.498.307.738.461h.009Z"
      />
      <path
        fill="#F2F2F2"
        d="M453.489 314.808c1.093.633 1.534 1.554 1.131 2.427l-2.779 6.082c-.393.863-1.553 1.544-3.048 1.774l-10.485 1.631c-1.495.23-3.086-.019-4.178-.652l-7.706-4.451c-1.093-.633-1.524-1.554-1.131-2.427l2.779-6.082c.393-.863 1.553-1.544 3.048-1.774l10.485-1.631c1.495-.23 3.086.019 4.179.652l7.705 4.451Z"
      />
      <path
        fill="gray"
        d="m453.01 305.476-2.473 5.41c-.354.767-1.38 1.372-2.712 1.573l-9.325 1.448-.029 10.591 9.335-1.449c1.332-.201 2.358-.806 2.712-1.573l2.473-5.41c.086-.192.125-.374.125-.566l.028-10.59c0 .192-.038.383-.124.566h-.01Z"
      />
      <path
        fill="#999"
        d="m434.772 313.342-6.863-3.962c-.738-.422-1.14-.998-1.131-1.593l-.028 10.591c0 .585.393 1.16 1.131 1.592l6.862 3.962c.977.566 2.396.786 3.718.575l.029-10.59c-1.322.211-2.75-.01-3.718-.575Z"
      />
      <path
        fill="#D9D9D9"
        d="M452.004 303.317c.978.566 1.361 1.381 1.006 2.158l-2.472 5.411c-.355.767-1.38 1.371-2.713 1.573l-9.325 1.448c-1.323.211-2.751-.009-3.719-.575l-6.862-3.962c-.977-.566-1.361-1.381-1.006-2.158l2.473-5.411c.354-.767 1.38-1.371 2.712-1.573l9.325-1.448c1.332-.202 2.751.009 3.719.575l6.862 3.962Z"
      />
      <path
        fill="#A3A3A3"
        d="M446.483 309.994c-3.44 1.986-9.028 1.976-12.488-.019-3.46-1.995-3.479-5.228-.038-7.213 3.441-1.986 9.028-1.976 12.488.019 3.46 1.995 3.479 5.228.038 7.213Z"
      />
      <path
        fill="gray"
        d="M433.957 304.823c3.441-1.985 9.028-1.976 12.488.019 1.275.739 2.08 1.641 2.425 2.59.585-1.63-.221-3.395-2.425-4.662-3.46-1.995-9.047-2.004-12.488-.019-2.166 1.257-2.962 3.003-2.387 4.624.336-.94 1.131-1.832 2.387-2.552Z"
      />
      <path
        fill="gray"
        d="M448.573 308.066c-.211.355-.498.71-.853 1.026a6.683 6.683 0 0 0-1.275-.93c-3.46-1.996-9.047-2.005-12.488-.019a6.636 6.636 0 0 0-1.236.901 4.494 4.494 0 0 1-.853-1.045c.421-.701 1.112-1.363 2.089-1.928 3.441-1.986 9.028-1.976 12.488.019.997.575 1.706 1.247 2.128 1.966v.01Z"
      />
      <path
        fill="gray"
        d="M446.924 309.716c-.144.096-.287.192-.441.278a8.966 8.966 0 0 1-1.658.748c-2.817-1.007-6.392-1.016-9.21-.038a10.419 10.419 0 0 1-1.62-.739 5.781 5.781 0 0 1-.479-.307 7.3 7.3 0 0 1 .441-.278c3.441-1.985 9.028-1.976 12.488.019.173.096.326.202.479.307v.01Z"
      />
      <g class="gear" [class.easter]="count >= 10" (click)="count = count + 1">
        <path
          fill="#0C66B9"
          d="m315.882 73.265-6.309 3.67c2.297.172 4.137-.3 5.632-1.166l6.309-3.669c-1.495.866-3.335 1.339-5.632 1.165ZM332.826 83.594l6.309-3.669c2.218-1.29 4.295-3.448 6.089-6.786l-6.309 3.669c-1.794 3.338-3.871 5.495-6.089 6.786ZM379.647 33.552 324.157 1.38c-2.8-1.622-5.333-1.764-7.158-.693l-6.309 3.669c1.825-1.071 4.373-.914 7.158.693l55.49 32.171c5.57 3.212 10.053 10.992 10.038 17.385l-.079 36.376c0 3.165-1.133 5.4-2.926 6.44l6.309-3.669c1.809-1.055 2.926-3.275 2.926-6.44l.079-36.376c.015-6.378-4.469-14.157-10.038-17.385Z"
        />
        <path
          fill="#1076D5"
          d="M373.322 37.22c5.57 3.213 10.054 10.992 10.038 17.386l-.079 36.375c-.015 6.378-4.531 8.96-10.1 5.748l-34.266-19.904c-6.246 11.653-16.032 8.897-22.577 5.117-3.996-2.314-6.639-4.865-6.781-5.007 7.568.567 10.305-5.858 11.28-10.566l-3.162-1.827c-5.554-3.212-10.053-10.992-10.037-17.385l.078-36.376c.016-6.377 4.547-8.944 10.101-5.747l55.49 32.171.015.016Z"
        />
        <path
          fill="#fff"
          d="m362.671 65.313-4.578-2.016c-.33 1.323-.85 2.457-1.526 3.37l2.879 5.763-4.279 2.473-3.619-5.354c-1.148.126-2.391 0-3.713-.363l-.503 4.96-6.073-3.464-.535-5.543a30.024 30.024 0 0 1-3.713-3.89l-3.603 1.23-4.311-7.37 2.864-2.489c-.677-1.7-1.212-3.432-1.542-5.133l-4.578-3.212v-6.96l4.562 2.03c.331-1.322.85-2.456 1.526-3.37l-2.879-5.763 4.295-2.472 3.603 5.354c1.133-.126 2.376 0 3.697.362l.504-4.96 6.073 3.464.535 5.543a30.085 30.085 0 0 1 3.712 3.89l3.603-1.244 4.311 7.37-2.863 2.488c.676 1.7 1.211 3.417 1.557 5.133l4.579 3.197v6.96l.015.016Zm-18.376-7.008c3.367 1.921 6.073.347 6.073-3.511s-2.753-8.535-6.104-10.456c-3.367-1.922-6.073-.347-6.073 3.511s2.753 8.535 6.104 10.456Z"
        />
      </g>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      @keyframes bounce {
        0% {
          transform: translateY(0px);
        }

        50% {
          transform: translateY(10px);
        }

        100% {
          transform: translateY(0px);
        }
      }

      @keyframes fellOff {
        0% {
          transform: translateY(0px);
        }
        100% {
          transform: translateY(1000px);
        }
      }

      .gear {
        animation: bounce 2s infinite ease-in-out;

        &.easter {
          animation-name: fellOff;
          animation-duration: 2s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
        }
      }
    `,
  ],
})
export class NotFoundPreviewComponent {
  count = 0;
}
